export default __webpack_public_path__ + "static/media/PCM.d09ac5c1.jpg";